import $ from "jquery";
window.$ = window.jQuery = $;

import slick from 'slick-carousel';
window.slick = slick;

import lightcase from 'lightcase';
window.lightcase = lightcase;

(function (module) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['jquery'], module);
    } else {
        // Browser globals
        module(jQuery);
    }
})(function (jQuery, undefined) {

    var // Number of pixels a pressed pointer travels before movestart
        // event is fired.
        threshold = 6,

        add = jQuery.event.add,

        remove = jQuery.event.remove,

        // Just sugar, so we can have arguments in the same order as
        // add and remove.
        trigger = function (node, type, data) {
            jQuery.event.trigger(type, data, node);
        },

        // Shim for requestAnimationFrame, falling back to timer. See:
        // see http://paulirish.com/2011/requestanimationframe-for-smart-animating/
        requestFrame = (function () {
            return (
                window.requestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.mozRequestAnimationFrame ||
                window.oRequestAnimationFrame ||
                window.msRequestAnimationFrame ||
                function (fn, element) {
                    return window.setTimeout(function () {
                        fn();
                    }, 25);
                }
            );
        })(),

        ignoreTags = {
            textarea: true,
            input: true,
            select: true,
            button: true
        },

        mouseevents = {
            move: 'mousemove',
            cancel: 'mouseup dragstart',
            end: 'mouseup'
        },

        touchevents = {
            move: 'touchmove',
            cancel: 'touchend',
            end: 'touchend'
        };


    // Constructors

    function Timer(fn) {
        var callback = fn,
            active = false,
            running = false;

        function trigger(time) {
            if (active) {
                callback();
                requestFrame(trigger);
                running = true;
                active = false;
            }
            else {
                running = false;
            }
        }

        this.kick = function (fn) {
            active = true;
            if (!running) { trigger(); }
        };

        this.end = function (fn) {
            var cb = callback;

            if (!fn) { return; }

            // If the timer is not running, simply call the end callback.
            if (!running) {
                fn();
            }
            // If the timer is running, and has been kicked lately, then
            // queue up the current callback and the end callback, otherwise
            // just the end callback.
            else {
                callback = active ?
                    function () { cb(); fn(); } :
                    fn;

                active = true;
            }
        };
    }


    // Functions

    function returnTrue() {
        return true;
    }

    function returnFalse() {
        return false;
    }

    function preventDefault(e) {
        e.preventDefault();
    }

    function preventIgnoreTags(e) {
        // Don't prevent interaction with form elements.
        if (ignoreTags[e.target.tagName.toLowerCase()]) { return; }

        e.preventDefault();
    }

    function isLeftButton(e) {
        // Ignore mousedowns on any button other than the left (or primary)
        // mouse button, or when a modifier key is pressed.
        return (e.which === 1 && !e.ctrlKey && !e.altKey);
    }

    function identifiedTouch(touchList, id) {
        var i, l;

        if (touchList.identifiedTouch) {
            return touchList.identifiedTouch(id);
        }

        // touchList.identifiedTouch() does not exist in
        // webkit yet… we must do the search ourselves...

        i = -1;
        l = touchList.length;

        while (++i < l) {
            if (touchList[i].identifier === id) {
                return touchList[i];
            }
        }
    }

    function changedTouch(e, event) {
        var touch = identifiedTouch(e.changedTouches, event.identifier);

        // This isn't the touch you're looking for.
        if (!touch) { return; }

        // Chrome Android (at least) includes touches that have not
        // changed in e.changedTouches. That's a bit annoying. Check
        // that this touch has changed.
        if (touch.pageX === event.pageX && touch.pageY === event.pageY) { return; }

        return touch;
    }


    // Handlers that decide when the first movestart is triggered

    function mousedown(e) {
        var data;

        if (!isLeftButton(e)) { return; }

        data = {
            target: e.target,
            startX: e.pageX,
            startY: e.pageY,
            timeStamp: e.timeStamp
        };

        add(document, mouseevents.move, mousemove, data);
        add(document, mouseevents.cancel, mouseend, data);
    }

    function mousemove(e) {
        var data = e.data;

        checkThreshold(e, data, e, removeMouse);
    }

    function mouseend(e) {
        removeMouse();
    }

    function removeMouse() {
        remove(document, mouseevents.move, mousemove);
        remove(document, mouseevents.cancel, mouseend);
    }

    function touchstart(e) {
        var touch, template;
        if (ignoreTags[e.target.tagName.toLowerCase()]) { return; }

        touch = e.changedTouches[0];

        template = {
            target: touch.target,
            startX: touch.pageX,
            startY: touch.pageY,
            timeStamp: e.timeStamp,
            identifier: touch.identifier
        };

        add(document, touchevents.move + '.' + touch.identifier, touchmove, template);
        add(document, touchevents.cancel + '.' + touch.identifier, touchend, template);
    }

    function touchmove(e) {
        var data = e.data,
            touch = changedTouch(e, data);

        if (!touch) { return; }

        checkThreshold(e, data, touch, removeTouch);
    }

    function touchend(e) {
        var template = e.data,
            touch = identifiedTouch(e.changedTouches, template.identifier);

        if (!touch) { return; }

        removeTouch(template.identifier);
    }

    function removeTouch(identifier) {
        remove(document, '.' + identifier, touchmove);
        remove(document, '.' + identifier, touchend);
    }


    function checkThreshold(e, template, touch, fn) {
        var distX = touch.pageX - template.startX,
            distY = touch.pageY - template.startY;

        if ((distX * distX) + (distY * distY) < (threshold * threshold)) { return; }

        triggerStart(e, template, touch, distX, distY, fn);
    }

    function handled() {
        this._handled = returnTrue;
        return false;
    }

    function flagAsHandled(e) {
        e._handled();
    }

    function triggerStart(e, template, touch, distX, distY, fn) {
        var node = template.target,
            touches, time;

        touches = e.targetTouches;
        time = e.timeStamp - template.timeStamp;
        template.type = 'movestart';
        template.distX = distX;
        template.distY = distY;
        template.deltaX = distX;
        template.deltaY = distY;
        template.pageX = touch.pageX;
        template.pageY = touch.pageY;
        template.velocityX = distX / time;
        template.velocityY = distY / time;
        template.targetTouches = touches;
        template.finger = touches ?
            touches.length :
            1;

        template._handled = handled;
        template._preventTouchmoveDefault = function () {
            e.preventDefault();
        };

        // Trigger the movestart event.
        trigger(template.target, template);
        fn(template.identifier);
    }


    function activeMousemove(e) {
        var timer = e.data.timer;

        e.data.touch = e;
        e.data.timeStamp = e.timeStamp;
        timer.kick();
    }

    function activeMouseend(e) {
        var event = e.data.event,
            timer = e.data.timer;

        removeActiveMouse();

        endEvent(event, timer, function () {
            setTimeout(function () {
                remove(event.target, 'click', returnFalse);
            }, 0);
        });
    }

    function removeActiveMouse(event) {
        remove(document, mouseevents.move, activeMousemove);
        remove(document, mouseevents.end, activeMouseend);
    }

    function activeTouchmove(e) {
        var event = e.data.event,
            timer = e.data.timer,
            touch = changedTouch(e, event);

        if (!touch) { return; }

        e.preventDefault();

        event.targetTouches = e.targetTouches;
        e.data.touch = touch;
        e.data.timeStamp = e.timeStamp;
        timer.kick();
    }

    function activeTouchend(e) {
        var event = e.data.event,
            timer = e.data.timer,
            touch = identifiedTouch(e.changedTouches, event.identifier);

        if (!touch) { return; }

        removeActiveTouch(event);
        endEvent(event, timer);
    }

    function removeActiveTouch(event) {
        remove(document, '.' + event.identifier, activeTouchmove);
        remove(document, '.' + event.identifier, activeTouchend);
    }


    function updateEvent(event, touch, timeStamp, timer) {
        var time = timeStamp - event.timeStamp;

        event.type = 'move';
        event.distX = touch.pageX - event.startX;
        event.distY = touch.pageY - event.startY;
        event.deltaX = touch.pageX - event.pageX;
        event.deltaY = touch.pageY - event.pageY;

        event.velocityX = 0.3 * event.velocityX + 0.7 * event.deltaX / time;
        event.velocityY = 0.3 * event.velocityY + 0.7 * event.deltaY / time;
        event.pageX = touch.pageX;
        event.pageY = touch.pageY;
    }

    function endEvent(event, timer, fn) {
        timer.end(function () {
            event.type = 'moveend';

            trigger(event.target, event);

            return fn && fn();
        });
    }

    function setup(data, namespaces, eventHandle) {
        add(this, 'movestart.move', flagAsHandled);

        return true;
    }

    function teardown(namespaces) {
        remove(this, 'dragstart drag', preventDefault);
        remove(this, 'mousedown touchstart', preventIgnoreTags);
        remove(this, 'movestart', flagAsHandled);
        return true;
    }

    function addMethod(handleObj) {
        if (handleObj.namespace === "move" || handleObj.namespace === "moveend") {
            return;
        }
        add(this, 'dragstart.' + handleObj.guid + ' drag.' + handleObj.guid, preventDefault, undefined, handleObj.selector);
        add(this, 'mousedown.' + handleObj.guid, preventIgnoreTags, undefined, handleObj.selector);
    }

    function removeMethod(handleObj) {
        if (handleObj.namespace === "move" || handleObj.namespace === "moveend") {
            return;
        }

        remove(this, 'dragstart.' + handleObj.guid + ' drag.' + handleObj.guid);
        remove(this, 'mousedown.' + handleObj.guid);
    }

    jQuery.event.special.movestart = {
        setup: setup,
        teardown: teardown,
        add: addMethod,
        remove: removeMethod,

        _default: function (e) {
            var event, data;
            if (!e._handled()) { return; }

            function update(time) {
                updateEvent(event, data.touch, data.timeStamp);
                trigger(e.target, event);
            }

            event = {
                target: e.target,
                startX: e.startX,
                startY: e.startY,
                pageX: e.pageX,
                pageY: e.pageY,
                distX: e.distX,
                distY: e.distY,
                deltaX: e.deltaX,
                deltaY: e.deltaY,
                velocityX: e.velocityX,
                velocityY: e.velocityY,
                timeStamp: e.timeStamp,
                identifier: e.identifier,
                targetTouches: e.targetTouches,
                finger: e.finger
            };

            data = {
                event: event,
                timer: new Timer(update),
                touch: undefined,
                timeStamp: undefined
            };

            if (e.identifier === undefined) {
                add(e.target, 'click', returnFalse);
                add(document, mouseevents.move, activeMousemove, data);
                add(document, mouseevents.end, activeMouseend, data);
            }
            else {
                e._preventTouchmoveDefault();
                add(document, touchevents.move + '.' + e.identifier, activeTouchmove, data);
                add(document, touchevents.end + '.' + e.identifier, activeTouchend, data);
            }
        }
    };

    jQuery.event.special.move = {
        setup: function () {
            add(this, 'movestart.move', jQuery.noop);
        },

        teardown: function () {
            remove(this, 'movestart.move', jQuery.noop);
        }
    };

    jQuery.event.special.moveend = {
        setup: function () {
            add(this, 'movestart.moveend', jQuery.noop);
        },

        teardown: function () {
            remove(this, 'movestart.moveend', jQuery.noop);
        }
    };

    add(document, 'mousedown.move', mousedown);
    add(document, 'touchstart.move', touchstart);

    if (typeof Array.prototype.indexOf === 'function') {
        (function (jQuery, undefined) {
            var props = ["changedTouches", "targetTouches"],
                l = props.length;

            while (l--) {
                // Проверяем, что jQuery.event.props определен и является массивом
                if (Array.isArray(jQuery.event.props) && jQuery.event.props.indexOf(props[l]) === -1) {
                    jQuery.event.props.push(props[l]);
                }
            }
        })(jQuery);
    }

});

import Inputmask from 'inputmask';
window.Inputmask = Inputmask;

$(document).ready(function () {
    Inputmask({
        mask: '+38 (XF9) 999 99 99',
        clearMaskOnLostFocus: true,
        clearIncomplete: true,
        definitions: {
            "X": {
                validator: "0",
            },
            "F": {
                validator: "[1-9]"
            }
        }
    }).mask('input[name="phone"]');
});

import './library/jquery.spincrement';
import './library/jquery.twentytwenty';

require('./components/modals');
require('./components/events');
require('./components/forms');
require('./components/menu');
require('./components/price');
require('./components/select');
require('./components/additions_script');

$(document).on('click', '.filters__heading', function (e) {
    var filtHead = $(this),
        filtP = filtHead.parents('.filters__item'),
        filtInner = filtP.find('.filters__inner');
    if (!filtHead.hasClass('active')) {
        filtHead.addClass('active');
        filtP.addClass('active');
        filtInner.addClass('active').stop().slideDown(200);
    } else {
        filtHead.removeClass('active');
        filtP.removeClass('active');
        filtInner.removeClass('active').stop().slideUp(200);
    }
});

$(document).on('ready', function () {
    function replace() {
        var href = window.location.href,
            path = 'path',
            search = window.location.search;
        var newHref = href.replace(search, '');
        if (href.indexOf(path) > 0) {
            if (href.indexOf(search) != 0) {
                window.location.href = newHref;
            }
        }
    };
    replace();
    $('.filters__item').each(function () {
        if ($(this).hasClass('active')) {
            $(this).find('.filters__inner').stop().slideDown();
        }
    })
    $('.product__desc').each(function () {
        if ($(this).find('table').length != 0 && $(this).find('table').closest('.table__scroll').length == 0) {
            $(this).find('table').wrap('<div class="table__scroll">')
        }
    });
})

/*= END modal =====================================================================================================================================================*/


/* Обновление корзины сверху count*/
function reloadTopCart() {
    $.ajax({
        type: "POST",
        url: "service/reload-top-cart",
        data: {},
        dataType: "json",
        success: function (data) {
            $("#top_cart").empty().html(data.top)
        }
    })
}
/* End Обновление корзины сверху count*/

$(document).on('ready', function () {

    /*= форма обратной связи =============================================================================*/
    $('.callback_container').click(function (e) {
        $('label.error').hide();
    });
    $('.callback_btn').click(function (e) {
        e.stopPropagation();
        e.preventDefault();
        $("#callback_form").fadeIn(300);
        $("#callback_success").fadeOut(300);
        $(this).parent('.callback_container').addClass('opened');
    });
    $('.callback_container_close').click(function (e) {
        e.stopPropagation();
        e.preventDefault();
        $(this).parent('.callback_container').removeClass('opened');
    });
    $(document).on('click', '.enter_name', function (e) {
        e.stopPropagation();
        e.preventDefault();
        $('#callback_form').toggleClass('phone').toggleClass('name');
    });
    $('.cancel_name').click(function (e) {
        e.stopPropagation();
        e.preventDefault();
        $('#callback_form').toggleClass('phone').toggleClass('name');
    });
    $('.do_name').click(function (e) {
        e.stopPropagation();
        e.preventDefault();
        var callback_name = $('.callback_name_input').val();
        if (callback_name != '') {
            $('.callback_note').html('<a class="enter_name" href="#">' + callback_name + '</a>, оставьте номер и мы Вам перезвоним');
            $('#callback_form').toggleClass('phone').toggleClass('name');
        }
    })
    $("#do_callback").on("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
        $("#callback_form").submit();
    });
    $("#callback_form").validate({
        submitHandler: function (form) {
            var formdata = $("#callback_form").serialize();
            $("#callback_form")[0].reset();
            $('.bmw_checkbox').closest('label').removeClass('checked');
            $.ajax({
                url: "service/send",
                type: 'POST',
                data: {
                    "data": formdata,
                    "subj": "callback"
                },
                success: function (data) {
                    $("#callback_form").fadeOut(300);
                    $("#callback_success").fadeIn(300);
                    $('.personal_data_note').css('opacity', '0');
                    $('.callback_container').addClass('success');
                    setTimeout(function () {
                        $('.callback_container_close').click();
                        $('.callback_container').removeClass('success');
                    }, 3000);
                }
            });
        }
    });

    /*= Определение хэша в адресной строке для запоминания таба =============================================================================================*/
    var href = window.location.hash;
    if (href != "") {
        $('.tabs__link').removeClass('active');
        $('.tabs__link[href*="' + href + '"]').addClass('active');
        if ($('[data-tab]').length != 0) {
            $('[data-tab]').removeClass('active');
            $('[data-tab="' + href + '"]').addClass('active');
        } else {
            $('.tabs__content').removeClass('active');
            $(href).addClass('active');
        }
    } else {
        $('.tabs__link').removeClass('active');
        $('.tabs__item').eq(0).find('.tabs__link').addClass('active');
        if ($('[data-tab]').length != 0) {
            $('[data-tab]').removeClass('active');
            $('[data-tab]').eq(0).addClass('active');
        } else {
            $('.tabs__content').removeClass('active');
            $('.tabs__content').eq(0).addClass('active');
        }
    }
    /*= END Определение хэша в адресной строке для запоминания таба =============================================================================================*/
    $('.tabs__link').each(function () {
        var tabsL = $(this);
        if (tabsL.hasClass('active')) {
            tabsLText = tabsL.text(),
                tabsLP = tabsL.parents('.tabs'),
                tabsLLabel = tabsLP.find('.tabs__label-active');
            if (tabsLLabel.length != 0) {
                tabsLLabel.html(tabsLText);
            }
        }
    })
    /*$("#search_form input[type='text']").typeahead({
        minLength: 3,
        source: function (query, process) {
            if (query.length > 2) $.ajax({
                type: "GET",
                dataType: "json",
                url: "service/typeahead",
                data: {
                    "query": $.trim(query)
                },
                error: function () {
                },
                success: function (data) {
                    process(data)
                }
            })
        },
        updater: function (item) {
            window.location.href = "search?search=" + item;
            return item;
        }
    });*/
    // $('#do_search').click(function(e){
    //     e.preventDefault();
    //     var searchVal = $("#search_form input[type='text']").val();
    //     var trimVal = $.trim(searchVal);
    //     console.log(trimVal);
    //     // $('.search__input').val(trimVal);
    //     // $('#search_form').submit();
    // });

    $("#label_date_by").datetimepicker({
        locale: 'ru',
        defaultDate: '',
        format: "YYYY-MM-DD",
        stepping: 15,
    });
    $('.forms select.selectpicker').selectpicker().change(function () {
        $(this).valid();
        $('input[name="BranchCode"').val($(this).val());
    });
    $('select.selectpicker').selectpicker();
    $("#form_service").validate({
        errorElement: 'span',
        errorClass: 'span__error',
        ignoreTitle: true,
        errorPlacement: function (error, element) {
            error.appendTo($(element).parents('.forms__value'));
        },
        highlight: function (element) {
            $(element).parents('.forms__row').addClass("forms__error");
        },
        unhighlight: function (element) {
            $(element).parents('.forms__row').removeClass("forms__error");
        },
        submitHandler: function (form) {
            var formdata = $("#form_service").serialize();
            $("#form_service")[0].reset();
            $.ajax({
                url: 'service/send',
                type: 'POST',
                data: {
                    "data": formdata,
                    "subj": "service"
                },
                success: function (data) {
                    if ($(form).find('#do_form_service').attr('data-type') == '205') {
                        window.location.href = '/stranica-blagodarnosti?flag=form&type=comercial'
                    } else if ($(form).find('#do_form_service').attr('data-type') == '203') {
                        window.location.href = '/stranica-blagodarnosti?flag=form&type=test_drive'
                    } else if ($(form).find('#do_form_service').attr('data-type') == '358') {
                        window.location.href = '/stranica-blagodarnosti?flag=form&type=buy'
                    } else {
                        window.location.href = '/stranica-blagodarnosti?flag=form'
                    }
                }
            });
        }

    });

    $("#do_form_service").click(function (e) {
        e.preventDefault();
        e.preventDefault();
        var formVal = $(this).closest('#form_service');
        var $captcha = formVal.find('.g-recaptcha');
        if ($('.g-recaptcha-response').length > 0) {
            var key = $('.g-recaptcha-response').val().trim();
        } else {
            var key = true;
        }
        if (key == '') {
            $captcha.addClass('error')
            $('.captcha-span').addClass('error')
        } else {
            $captcha.removeClass('error')
            $('.captcha-span').removeClass('error')
            formVal.submit();
        }
        var gender = $('.radio__holder').find('input');
        gender.each(function () {
            if ($(this).prop('checked')) {
                $('input[name="check_gender"]').val($(this).val());
            }
        })
        // $("#form_service").submit();
    });

    $("#form_moto_tour_request").validate({
        errorElement: 'span',
        errorClass: 'span__error',
        ignoreTitle: true,
        errorPlacement: function (error, element) {
            error.appendTo($(element).parents('.forms__value'));
        },
        highlight: function (element) {
            $(element).parents('.forms__row').addClass("forms__error");
        },
        unhighlight: function (element) {
            $(element).parents('.forms__row').removeClass("forms__error");
        },
        submitHandler: function (form) {
            var formdata = $("#form_moto_tour_request").serialize();
            $("#form_moto_tour_request")[0].reset();
            $.ajax({
                url: 'service/send',
                type: 'POST',
                data: {
                    "data": formdata,
                    "subj": "moto_tour"
                },
                success: function (data) {
                    window.location.href = '/openseason2024-success'
                }
            });
        }
    });

    $("#form_moto_tour_request_btn").click(function (e) {
        e.preventDefault();
        e.preventDefault();
        $("#form_moto_tour_request").submit();
    });

    var maxSize = 5242880;
    $('.label-text').click(function (e) {
        var labelText = $(this).closest('.input-file-wrap').find('.label-text').text();
        $('input[type=file]').change(function (e) {
            if ($(this)[0].files[0].size > maxSize) {
                $("#filesize").addClass('active');
                return;
            } else {
                $("#filesize").removeClass('active');
                var el = $(this);
                var labelReload = $(this).closest('.input-file-wrap').find('.label-reload');
                var labelRemove = $(this).closest('.input-file-wrap').find('.label-remove');
                var inputText = $(this).val().split('/').pop().split('\\').pop();
                var label = $(this).closest('.input-file-wrap').find('.label-text');
                var val = $(this).val().toLowerCase(),
                    regex = new RegExp("(.*?)\.(jpeg|png|jpg|pdf)$");
                if (!(regex.test(val))) {
                    $(this).val('');
                    $('#fileexttension').addClass('active');
                    label.html(labelText);
                    labelRemove.addClass('hide');
                    labelReload.addClass('hide');
                } else {
                    $('#fileexttension').removeClass('active');
                    label.html(inputText);
                    el.parent().next('.input-file-wrap').css('display', 'flex');
                    labelRemove.removeClass('hide');
                    labelReload.removeClass('hide');
                }
            }
        });

        $('.label-remove').click(function (e) {
            $(this).closest('.input-file-wrap').find('.input-file').val('');
            var fileName = $(this).closest('.input-file-wrap').find('.label-text');
            var labelReload = $(this).closest('.input-file-wrap').find('.label-reload');
            var labelRemove = $(this).closest('.input-file-wrap').find('.label-remove');
            fileName.attr('title', '');
            fileName.html(labelText);
            labelRemove.addClass('hide');
            labelReload.addClass('hide');
            if (!$(this).parent().next('.input-file-wrap').find('.input-file').val()) {
                $(this).parent().next('.input-file-wrap').css('display', 'none');
            } else {

            }
        });
    });

    $("#form_motorcycle_auction").validate({
        errorElement: 'span',
        errorClass: 'span__error',
        ignoreTitle: true,
        errorPlacement: function (error, element) {
            error.appendTo($(element).parents('.forms__value'));
        },
        highlight: function (element) {
            $(element).parents('.forms__row').addClass("forms__error");
        },
        unhighlight: function (element) {
            $(element).parents('.forms__row').removeClass("forms__error");
        },
        submitHandler: function (form) {
            $('#file-error').remove();
            var formdata = $("#form_motorcycle_auction").serialize();
            var inputs = $('.input-file');
            let $data = {};
            for (let i = 0; i < inputs.length; i++) {
                let element = inputs[i];
                let next_el = (inputs[i + 1]) ? (inputs[i + 1]) : null;
                if (element != null && element.files.length) {
                    let reader = new FileReader();
                    reader.onload = function () {
                        let key = 'file_' + i;
                        let value = reader.result;
                        $data[key] = value;
                        if (next_el == null || !next_el.files.length) {
                            setTimeout(function () {
                                $.ajax({
                                    type: 'POST',
                                    url: 'service/load-file',
                                    data: {
                                        "data": $data,
                                        "subj": "sell_motorcycle"
                                    },
                                    success: function (response) {
                                        if (response.success == 200) {
                                            var uploadedFile = response.file_name;
                                            $("#form_motorcycle_auction")[0].reset();
                                            sendTextFields('', formdata, uploadedFile);
                                        } else {
                                            $('.forms__row.file').before('<span id="file-error" style="margin-bottom: 10px;color: #a94442 !important; display: block" class="span__error">Цей тип файлу не підтримується. Завантажте PDF, JPEG, JPG, PNG.</span>')
                                        }
                                    },
                                    error: function (response) { },
                                });
                            }, 100);
                        }
                    };
                    reader.readAsDataURL(inputs[i].files[0]);
                }
            }
        }
    });

    $("#motorcycle_auction_btn").click(function (e) {
        e.preventDefault();
        e.preventDefault();
        $("#form_motorcycle_auction").submit();
    });

    function sendTextFields(item = '', formdata, file = '') {
        var dataForm;
        dataForm = {
            data: formdata,
            file: file,
            subj: 'motorcycle_auction',
        }
        $.ajax({
            url: 'service/send',
            type: 'POST',
            data: dataForm,
            success: function (data) {
                window.location.href = '/stranica-blagodarnosti?flag=motorcycle_auction'
            },
            error: function (response) {
                location.reload(true);
            },
        })
    };

    /*lightcase*/
    $('a[data-rel="lightcase:myCollection"]').lightcase({
        transition: 'scrollHorizontal',
        showSequenceInfo: true,
        showTitle: true,
        showCaption: true,
        shrinkFactor: 1,
        swipe: true,
        navigateEndless: false,
        maxWidth: '100%',
        maxHeight: '100%'
    });
    /*END lightcase*/

    /*= Клик на кнопки ВВЕРХ =============================================================================================*/
    $(".bmw__up").on("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 450);
    });
    /*= END Клик на кнопки ВВЕРХ =============================================================================================*/

    /*= Клик на кнопку "бургер", для вызова меню =============================================================================================*/

    /*= END Клик на кнопку "бургер", для вызова меню =============================================================================================*/

    /*= Клик на темную область для закрытия меню =============================================================================================*/
    $('.header__overlay').on('click', function () {
        if ($('body').hasClass('overflow')) {
            $('body').removeClass('overflow');
        }
        if ($('.header').hasClass('is_active')) {
            $('.header').removeClass('is_active');
        }
        if ($('.burger').hasClass('is_active')) {
            $('.burger').removeClass('is_active');
        }
        if ($('.search').hasClass('is_active')) {
            $('.search').stop().slideUp(300, function () {
                $(this).removeAttr('style').removeClass('is_active');
                $(this).find('.input').val('')
            });
        }
        if ($('.menu').hasClass('is_active')) {
            $('.menu').stop().slideUp(300, function () {
                $(this).removeAttr('style').removeClass('is_active');
            });

            setTimeout(function () {
                $('.header__logo').removeClass('open').eq(0);
            }, 200);
        }
    })
    /*= END Клик на темную область для закрытия меню =============================================================================================*/

    /*= Фокус на input в меню =============================================================================================*/
    $('.input').focus(function () {
        $(this).parents('.search__holder').addClass('is_active');
    })
    $('.input').blur(function () {
        if ($(this).val() == '') {
            $(this).parents('.search__holder').removeClass('is_active');
        }
    })
    $('.in__input').on('click', function () {
        $('.input').trigger('focus');
    })
    /*= END Фокус на input в меню =============================================================================================*/
})

$(window).on('load', function () {
    $('iframe').each(function () {
        if (typeof $(this).attr('data-src') !== typeof undefined && $(this).attr('data-src') !== false) {
            $(this).attr('src', $(this).attr('data-src'));
        }
    })
})

/*= Проверка куда скроллим) Вниз? или вверх? От этого появляется или исчезает хедер  =============================================================================================*/
var tempScrollTop, currentScrollTop = 0;
$(window).on('load scroll', function () {
    var anotherUp = $('.footer__up'),
        anotherUpTop = anotherUp.offset().top,
        slogan = $('.footer_slogan_js'),
        sloganTop = slogan.offset().top,
        windowTop = $(this).scrollTop(),
        windowH = $(window).height(),
        header = $('.header__top'),
        headerH = header.outerHeight();
    if ($(window).scrollTop() > 200) {
        $(".fixed__up").addClass('active');
        $(".callback").addClass('higher');
        if ((windowTop + windowH) >= anotherUpTop) {
            $(".fixed__up").removeClass('active');
            $(".callback").removeClass('higher');
        } else {
            $(".fixed__up").addClass('active');
        }
        if ((windowTop + windowH) >= sloganTop) {
            slogan.addClass('is_active')
        } else {
            slogan.removeClass('is_active')
        }
    } else {
        $(".fixed__up").removeClass('active');
        $(".callback").removeClass('higher');
    }
    if (windowTop >= headerH) {
        $('.header:not(.is_active)').removeAttr('style');
        $('.header:not(.is_active)').removeClass('up__top');
    }
    if (tempScrollTop < windowTop) {
        if (windowTop >= headerH) {
            if (!slogan.hasClass('is_active')) {
                $('.header:not(.is_active)').addClass('up__top')
                $('.header.up__top:not(.is_active)').css({
                    'top': -headerH
                })
            }
        } else {
            $('.header:not(.is_active)').removeAttr('style');
            $('.header:not(.is_active)').removeClass('up__top');
        }
    }
    else if (tempScrollTop > windowTop) {
        $('.header:not(.is_active)').removeClass('up__top')
    }
    tempScrollTop = windowTop;
});
/*= END Проверка куда скроллим) Вниз? или вверх? От этого появляется или исчезает хедер  =============================================================================================*/

$(window).on('load resize', function () {
    // var allHeader = $('.header'), 120px
    var allHeader = $('.header__top'), /*85px*/
        allHeaderH = allHeader.outerHeight();
    $('main').css({
        'padding-top': allHeaderH
    })
    /*= Переопределение максимальной высоты нижнего меню в хедере для инициализации скролла, если не влазит контент =============================================================================================*/
    var headerBottom = $('.header__bottom'),
        windowH = $(window).height(),
        headerTopH = $('.header__top').height();
    headerBottom.css({
        'max-height': windowH - headerTopH,
    })
    /*= END Переопределение максимальной высоты нижнего меню в хедере для инициализации скролла, если не влазит контент =============================================================================================*/

    /*= Переделка меню ОЙ ПИЗДЕЦ =============================================================================================*/
    if (window.innerWidth < 1024) {
        $('[data-link]').each(function () {
            var dataLink = $(this),
                dataLinkAttr = dataLink.attr('data-link');
            $('[data-link=' + dataLinkAttr + ']').closest('.menu__item').append($('[data-inner="' + dataLinkAttr + '"]'));
            if ($('[data-inner="' + dataLinkAttr + '"]').hasClass('is_active')) {
                slickModel = $('[data-inner="' + dataLinkAttr + '"]').children('.inner__list--model');
                if (slickModel.length != 0) {
                    slickModel.each(function () {
                        if (!$(this).hasClass('slick-slider')) {
                            $(this).slick({
                                arrows: false,
                                dots: false,
                                slidesToShow: 3,
                                responsive: [
                                    {
                                        breakpoint: 768,
                                        settings: {
                                            slidesToShow: 2,
                                        }
                                    },
                                    {
                                        breakpoint: 568,
                                        settings: {
                                            slidesToShow: 1
                                        }
                                    }
                                ]
                            })
                        }
                    })
                }
            }
        })
    } else {
        $('[data-inner]').each(function () {
            var dataInner = $(this),
                dataInnerParentAttr = dataInner.attr('data-parent');
            $('.menu__list.' + dataInnerParentAttr).append($('[data-parent="' + dataInnerParentAttr + '"]'));
            if ($('[data-parent="' + dataInnerParentAttr + '"]').hasClass('is_active')) {
                slickModel = $('[data-parent="' + dataInnerParentAttr + '"]').children('.inner__list--model');
                if (slickModel.length != 0) {
                    slickModel.each(function () {
                        if ($(this).hasClass('slick-slider')) {
                            $(this).slick('destroy')
                        }
                    })
                }
            }
        })
    }
    /*= END Переделка меню ОЙ ПИЗДЕЦ =============================================================================================*/
})


$(document).ready(function () {

    $('.js__addition_three_videos').each(function () {
        const video = $(this).find('video')[0];
        video.play();
        video.pause();
    });

    var start = true;
    function isElementInViewport(element) {
        var rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    function handleVideoAutoplay() {
        if (start) {
            $('.js__addition_three_videos').each(function () {
                var videoOne = $(this).find('.video_one video')[0];
                var videoTwo = $(this).find('.video_two video')[0];
                if (isElementInViewport(videoOne)) {
                    if (videoOne.paused) {
                        videoOne.play();

                        start = false
                    }
                }

                videoOne.addEventListener('ended', function () {
                    if (!videoOne.paused) {
                        videoOne.pause();
                    }

                    const thisBlock = $(this);
                    thisBlock.closest('.video_one').hide();
                    thisBlock.closest('.js__addition_three_videos').find('.video_two').show();
                    if (videoTwo.paused) {
                        videoTwo.play();
                        setTimeout(function () {
                            thisBlock.closest('.js__addition_three_videos').find('.video_two .js__addition_three_btn').addClass('js__active')
                        }, 1500)
                    }
                });
            });
        }
    }

    function allVideo() {
        // $('.js__video_solo').each(function () {
        //     var video = $(this).find(' video')[0];
        //     if (isElementInViewport(video)) {
        //         if (video.paused) {
        //             video.play();
        //         }
        //     }
        // });
    }

    $(document).on('click', '.video_two .js__addition_three_btn', function () {
        $(this).removeClass('js__active');
        const parentBlockTwo = $(this).closest('.video_two');
        parentBlockTwo.hide();

        if (!parentBlockTwo.find('video')[0].paused) {
            parentBlockTwo.find('video')[0].pause();
        }

        const parentVideo = parentBlockTwo.closest('.js__addition_three_videos').find('.video_there');

        parentVideo.show();
        var videoThere = parentVideo.find('video')[0];
        if (videoThere.paused) {
            videoThere.play();
        }

        videoThere.addEventListener('ended', function () {
            setTimeout(function () {
                parentVideo.find('.js__addition_three_btn').addClass('js__active')
            }, 100)
        });
    })

    $(document).on('click', '.video_there .js__addition_three_btn', function () {
        start = true;
        $(this).removeClass('js__active');
        const parentBlockTwo = $(this).closest('.video_there');
        parentBlockTwo.hide();

        if (!parentBlockTwo.find('video')[0].paused) {
            parentBlockTwo.find('video')[0].pause();
        }

        const parentVideo = parentBlockTwo.closest('.js__addition_three_videos').find('.video_one');
        parentVideo.show();
        handleVideoAutoplay();
    });

    $(window).on('scroll', handleVideoAutoplay);
    $(window).on('scroll', allVideo);
    handleVideoAutoplay();
    allVideo();
});
